import React from "react";

import {
  Wrap,
  FormWrapper,
  CustomInput,
  Label,
  SubmitBtn,
  ButtonSection,
  Messages,
  Space,
  CustomSelect,
  Privacy,
} from "./styles";

export default function RegistrationMask(props) {
  return (
    <Wrap>
      <div>
        <h2>
          CAMBIAMO INSIEME IL FUTURO, <br />
          UNA CLASSE PER VOLTA
        </h2>
      </div>
      {props.type === "register" ? (
        <div>
          <FormWrapper>
            <div>
              <h3>
                REGISTRATI PER ACCEDERE AI MATERIALI <br /> E RESTARE INFORMATO SULLE ATTIVITÀ <br />
                DI ISTITUTO OIKOS
              </h3>
              <div>
                <Label>
                  Nome:
                  <CustomInput id="name" type="text" value={props.name} onChange={props.onChangeName} />
                </Label>
                <Space />
                <Label>
                  Cognome:
                  <CustomInput id="surname" type="text" value={props.surname} onChange={props.onChangeSurName} />
                </Label>
              </div>
              <Label>
                <div>
                  Mail:
                  <span>Servirà per accedere</span>
                </div>
                <CustomInput type="text" value={props.mailValue} onChange={props.onChangeMail} />
              </Label>
              <Label>
                <div>
                  Password:
                  <span>Ricorda la tua password</span>
                </div>
                <CustomInput type="text" value={props.password} onChange={props.onChangePsw} />
              </Label>
              <Label>
                <div>
                  Ripeti Password:
                  <span>Inserisci nuovamente la tua password</span>
                </div>
                <CustomInput type="text" value={props.passwordBis} onChange={props.onChangePswBis} />
              </Label>
              <div>
                <Label>
                  Scuola:
                  <CustomSelect name="school" id="school" onChange={props.onChangeSchool}>
                    <option value=""></option>
                    <option value="infanzia">INFANZIA</option>
                    <option value="primaria">PRIMARIA</option>
                    <option value="secondaria_primo_grado">SECONDARIA I GRADO</option>
                    <option value="secondaria_secondo_grado">SECONDARIA II GRADO</option>
                    <option value="altro">ALTRO</option>
                  </CustomSelect>
                </Label>
                <Space />
                <Label>
                  <div>
                    Città:
                    <span>Città della scuola</span>
                  </div>
                  <CustomInput id="city" type="text" value={props.city} onChange={props.onChangeCity} />
                </Label>
              </div>
              <Privacy>
                <input
                  type="checkbox"
                  id="privacy"
                  name="privacy"
                  onClick={props.onCheckPrivacy}
                  checked={props.privacyCheck}
                />
                <label for="privacy">
                  Accetto i termini della{" "}
                  <a href="https://www.istituto-oikos.org/policy" target="_blank" rel="noopener noreferrer">
                    {" "}
                    privacy
                  </a>
                </label>
              </Privacy>

              {(props.error || props.inlineMessage) && (
                <Messages color={props.inlineMessage ? "green" : "red"}>
                  {props.inlineMessage ? props.inlineMessage : props.error}
                </Messages>
              )}
              <ButtonSection formType={props.type}>
                <SubmitBtn formType={props.type} type="submit" value="REGISTRATI" onClick={props.handleRegister} />
              </ButtonSection>
              <a href={"#/project?login"}>ACCEDI SE GIÀ ISCRITTO</a>
            </div>
          </FormWrapper>
        </div>
      ) : (
        <div>
          <FormWrapper>
            <div>
              <h3>TRASFORMA I TUOI STUDENTI IN “AGENTI 0 EMISSIONI”: ACCEDI AI MATERIALI</h3>
              <Label>
                Mail:
                <CustomInput type="text" value={props.mailValue} onChange={props.onChangeMail} />
              </Label>
              <Label>
                Password:
                <CustomInput type="text" value={props.password} onChange={props.onChangePsw} />
              </Label>
              <Messages color={props.inlineMessage ? "green" : "red"}>
                {props.inlineMessage ? props.inlineMessage : props.error}
              </Messages>
              <ButtonSection formType={props.type}>
                <SubmitBtn formType={props.type} type="submit" value="ACCEDI" onClick={props.handleLogin} />
                <a href={"#/project?register"}>NON HO UN ACCOUNT</a>
              </ButtonSection>
            </div>
          </FormWrapper>
        </div>
      )}
    </Wrap>
  );
}
